import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";

import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Layout from "Layout";
import { animateScroll as scroll } from 'react-scroll';

import {
  ListAlt,
  Delete,
  FileCopy,
  Edit,
} from "@material-ui/icons";

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from "@material-ui/core/Collapse";

import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import Alert from "@material-ui/lab/Alert";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";
import { saveAs } from "file-saver";
import googleAnalytics from "fuction/googleAnalytics";
import {useQueryString} from "Hooks/useQueryString";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  ".makeStyles-container": {
    paddingLeft: "140px",
    marginLeft: "1000px",
  },
  container: {
    paddingLeft: "140px"
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    /*width: "1385px",*/
  },
  table: {
    overflowX: "auto",
  },
  tableheader: {
    /*backgroundColor: "#eff5ff",*/
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "105px",
  },
  limitCol: {
    textAlign: "center",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  taskname: {
    width: "250px",
  },
  desc: {
    fontSize: "90%",
  },
  date: {
    width: "120px",
    whiteSpace: "pre-wrap",
    fontSize: "90%",
  },
  status: {
    width: "160px",
  },
  download: {
    width: "150px",
    textAlign: "center",
  },
  icon: {
    textAlign: "center",
    width: "50px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  buttonGrey: {
    color: "rgb(180, 180, 180)",
  },
}));

export default function Setting(props) {
  const messages = message();
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const classes = useStyles();
  const queryParams = useQueryString();
  const activeGroup = auth.state.activeGroup;

  const [nomaltasks, setNormalTasks] = React.useState([]);
  const [dailytasks, setDailyTasks] = React.useState([]);
  const [maxInfos, setMaxInfos] = React.useState(0);
  const [openFlag, setOpenFlag] = React.useState([])

  const [success, setSuccess] = React.useState(null);
  const [isError, setIsError] = React.useState(false);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [errorMessage, setErrorMessage] = React.useState("");

  const StyledTableCell = withStyles(() => ({
    root: {
      padding: "6px",
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
      cursor: "pointer",
    },
  }))(TableRow);

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  // 投稿分類有効確認
  const isAnalysis = () => {
    if (JSON.parse(localStorage.getItem("user"))?.options?.analysis == true || JSON.parse(localStorage.getItem("user"))?.options?.analysis== "true") {
        return true;
    }
    else {
      return false;
    }
  };

  // 毎日予約のタスクの並べ替え
  const sortDailyData = (data) => {
    let dailyArry = [];
    // 毎日予約フラグのあるデータは先頭にする
    let mainTask = data.find((row) => { return row.daily_iterate } );
    dailyArry.push(mainTask);
    // 毎日予約フラグのないデータだけで逆順で並べなおす
    let reversedData = data.reverse()
    reversedData.map((row => {
      if (!row.daily_iterate) { dailyArry.push(row) }
    }));
    setDailyTasks(dailyArry);
  };

  const fetchData = () => {
    if (!auth.state.activeGroup) {
      return;
    }
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }
    // タスクを取得
    request({
      method: "GET",
      url: `config/:account_id/analysis/information/${auth.state.activeGroup}`,
    }).then((data) => {
      if (data.data.normal.length > 0) {
        let reversedData = data.data.normal.reverse()
        setNormalTasks(reversedData);
      } else {
        setNormalTasks([]);
      }
      if (data.data.daily.length > 0) {
        sortDailyData(data.data.daily);
      } else {
        setDailyTasks([]);
      }
    });

    // タスク予約登録上限数取得
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_infos",
        ]
      },
    }).then((account) => {
      setMaxInfos(account.data.max_infos);
    });

    setIsError(false);
    scrollToTop()
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 投稿分類タスク一覧";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess("create");
    }
    if (props.location.search.indexOf("copy") > -1) {
      setSuccess("copy");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess("edit");
    }

    if(!isAnalysis()) return;

    fetchData();

    // パカパカ
    let subArry = [];
    nomaltasks.map((row => {
      subArry.push(false);
    }));
    setOpenFlag(subArry);
  }, [auth.state.activeGroup]);

  // 詳細
  const onClickDetailButton = (id) => {
    props.history.push(`/analysistask/detail/${id}?activeGroup=${activeGroup}`);
  };
  // 編集
  const onClickEditButton = (id) => {
      props.history.push(`/analysistask/edit/${id}?activeGroup=${activeGroup}`);
  };
  // 新規登録
  const onClickCreateButton = (type) => {
    let taskNum = nomaltasks.length + ((dailytasks.length > 0) ? 1 : 0);
    if (taskNum >= maxInfos) {
      setIsError(true);
      setErrorMessage(messages.errorMsg.overLimit);
      scrollToTop()
    } else {
      props.history.push(`/analysistask/create/${type}?activeGroup=${activeGroup}`);
    }
  };
  //複製
  const onClickCopyButton = (id) => {
    let taskNum = nomaltasks.length + ((dailytasks.length > 0) ? 1 : 0);
    if (taskNum >= maxInfos) {
      setIsError(true);
      setErrorMessage(messages.errorMsg.overLimit);
      scrollToTop()
    } else {
      props.history.push(`/analysistask/copy/${id}?activeGroup=${activeGroup}`);
    }
  };
  // ダウンロード
  const onClickDownload = (row) => {
    let id = row.id;
    request({
      method: "GET",
      url: `data/:account_id/analysis/download/${auth.state.activeGroup}/${id}`,
      responseType: "blob",
      headers: { Accept: "application/csv" },
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/csv",
      });
      // データがあればcsvダウンロード
      if (blob.size > 0) {
        let filename = row.name + "-" + dayjs(row.range_from).format("YYYYMMDD") + "-" + dayjs(row.range_until).format("YYYYMMDD") + ".csv";
        saveAs(blob, filename);
        setIsShowModal(false);
        setSuccess("download");
        scrollToTop();
      } else {
        setIsError(true);
        setErrorMessage(messages.errorMsg.blobSizeZero);
        scrollToTop();
      }
    })
    .catch((error) => {
      setIsError(true);
      setErrorMessage(messages.errorMsg.blobSizeZero);
      scrollToTop();
    });
  };

  // 削除
  const openDialog = (id, status) => {
    setSuccess(null);
    if (status === "running") {
      setIsError(true);
      setErrorMessage(messages.errorMsg.undeliteable);
      scrollToTop()
    } else {
      setDeleteId(id);
      setIsShowModal(true);
    }
  };
  const deleteTask = () => {
    request({
      method: "DELETE",
      url: `config/:account_id/analysis/information/${auth.state.activeGroup}/${deleteId}`,
    }).then(() => {
      fetchData();
      setIsShowModal(false);
      setSuccess("delete");
      scrollToTop();
    })
    .catch((error) => {
      setIsError(true);
      setErrorMessage(messages.errorMsg.undeliteable);
      scrollToTop();
    });
  };

  // 毎日予約の削除disableチェック
  const deleteDailyButtonDisable = (daily_iterate) => {
    // 毎日予約設定以外は削除可能
    if (!daily_iterate) { return false }
    let disableFlag = 0;
    dailytasks.map((row => {
      if (row.status === "running" || row.status === "waiting") { disableFlag++ }
    }));
    // 実行中がひとつでもあれば削除不可
    if (disableFlag > 0) {
      return true;
    } else {
      return false;
    }
  }
  // 毎日予約の編集disableチェック
    const editDailyButtonDisable = (daily_iterate) => {
      // 毎日予約設定以外は削除可能
      if (!daily_iterate) { return false }
      let disableFlag = 0;
      dailytasks.map((row => {
        if (row.status === "running" || row.status === "waiting") { disableFlag++ }
      }));
      // 実行中がひとつでもあれば削除不可
      if (disableFlag > 0) {
        return true;
      } else {
        return false;
      }
    }

  // 期間指定新規登録ボタンのdisableチェック
  const createButtonDisable = () => {
    let taskNum = nomaltasks.length + ((dailytasks.length > 0) ? 1 : 0);
    if (taskNum >= maxInfos) {
      return true;
    } else {
      return false;
    }
  }
  // 毎日予約新規登録ボタンのdisableチェック
  const createDailyButtonDisable = () => {
    if (dailytasks.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);


  function NormalTaskRow(props) {
    const {row, index} = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell className={classes.icon}>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          <TableCell component="th" scope="row" className={classes.taskname}>
            {row.name}
          </TableCell>
          <TableCell align="left" className={classes.date}>
            <p>{dayjs(row.range_from).format("YYYY/MM/DD")}<br />{dayjs(row.range_from).format("HH:mm:ss")}</p>
          </TableCell>
          <TableCell align="left" className={classes.date}>
            <p>{dayjs(row.range_until).format("YYYY/MM/DD")}<br />{dayjs(row.range_until).format("HH:mm:ss")}</p>
          </TableCell>
          <TableCell align="left" className={classes.status}>
            <p>{row.result}</p>
          </TableCell>
          <TableCell align="right" className={classes.icon}>
            <IconButton
            color="primary"
            aria-label="Detail"
            onClick={() => onClickDetailButton(row.id)}
            >
            <ListAlt />
          </IconButton>
          </TableCell>
          {(auth.state.user.admin) ?
          <TableCell align="right" className={classes.icon}>
            <IconButton
            color="primary"
            aria-label="Edit"
            disabled={!auth.state.user.admin || (row.status === "waiting" || row.status === "running" || row.status === "complete")}
            onClick={() => onClickEditButton(row.id)}
            >
            <Edit />
          </IconButton>
          </TableCell>
          : "" }
          <TableCell align="right" className={classes.download}>
            <p>
            {(row.status === "complete") ?
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => onClickDownload(row)}
            >
            ダウンロード
            </Button>
            : "-" }
            </p>
          </TableCell>
          {(auth.state.user.admin) ?
          <TableCell align="right" className={classes.icon}>
            <IconButton
            className={(row.status != "running") ? classes.buttonRed : classes.buttonGrey}
            color="primary"
            aria-label="Delete"
            disabled={!auth.state.user.admin || (row.status === "running" || row.status === "waiting")}
            onClick={() => openDialog(row.id, row.status)}
            >
            <Delete />
            </IconButton>
          </TableCell>
          : "" }
          {(auth.state.user.admin) ?
          <TableCell align="right" className={classes.icon}>
            <IconButton
            className={(createButtonDisable()) ? classes.buttonGrey : ""}
            color="primary"
            aria-label="Copy"
            disabled={!auth.state.user.admin || createButtonDisable()}
            onClick={() => onClickCopyButton(row.id)}
            >
            <FileCopy />
          </IconButton>
          </TableCell>
          : "" }
        </TableRow>

        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={(auth.state.user.admin) ? 11 : 8} >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Table>
              <TableBody>
              <TableRow>
              <TableCell colSpan={4}><p>概要：{row.desc}</p> </TableCell>
              </TableRow>
              <TableRow>
              <TableCell><p>対象ツイート数：{(row.status === "complete") ? row.num_tweets : (row.status === "running") ? "処理中" : "実行前"}</p> </TableCell>
              <TableCell><p>処理開始日時：{(row.status === "complete") ? dayjs(row.started_at).format("YYYY/MM/DD")+" "+dayjs(row.started_at).format("HH:mm:ss") : (row.status === "running") ? "処理中" : "実行前"}</p></TableCell>
              <TableCell><p>処理終了日時：{(row.status === "complete") ? dayjs(row.finished_at).format("YYYY/MM/DD")+" "+dayjs(row.finished_at).format("HH:mm:ss") : (row.status === "running") ? "処理中" : "実行前"}</p></TableCell>
              <TableCell><p>ダウンロード有効期限：{(row.status === "complete") ? dayjs(row.expired_at).format("YYYY/MM/DD")+" "+dayjs(row.expired_at).format("HH:mm:ss") : (row.status === "running") ? "処理中" : "実行前"}</p></TableCell>
              </TableRow>
              </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function DailyTaskRow(props) {
    const {row, index} = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell className={classes.icon}>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          <TableCell component="th" scope="row" className={classes.taskname}>
            {row.name}
          </TableCell>
          <TableCell align="left" className={classes.date}>
            <p>
            {(row.daily_iterate) ? "毎日" : dayjs(row.range_from).format("YYYY/MM/DD")}
            {(row.daily_iterate) ? "" : <br />}
            {(row.daily_iterate) ? "" : dayjs(row.range_from).format("HH:mm:ss")}
            </p>
          </TableCell>
          <TableCell align="left" className={classes.date}>
            <p>
            {(row.daily_iterate) ? "毎日" : dayjs(row.range_until).format("YYYY/MM/DD")}
            {(row.daily_iterate) ? "" : <br />}
            {(row.daily_iterate) ? "" : dayjs(row.range_until).format("HH:mm:ss")}
            </p>
          </TableCell>
          <TableCell align="left" className={classes.status}>
            <p>{row.result}</p>
          </TableCell>
          <TableCell align="right" className={classes.icon}>
            <IconButton
            color="primary"
            aria-label="Detail"
            onClick={() => onClickDetailButton(row.id)}
            >
            <ListAlt />
          </IconButton>
          </TableCell>
          {(auth.state.user.admin) ?
          <TableCell align="right" className={classes.icon}>
            {(auth.state.user.admin && row.daily_iterate) ?
              <IconButton
              color="primary"
              aria-label="Edit"
              disabled={!auth.state.user.admin || editDailyButtonDisable(row.daily_iterate)}
              onClick={() => onClickEditButton(row.id)}
              >
              <Edit />
            </IconButton>
            : "-" }
          </TableCell>
          : "" }
          <TableCell align="right" className={classes.download}>
            <p>
            {(row.status === "complete") ?
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => onClickDownload(row)}
            >
            ダウンロード
            </Button>
              : "-" }
            </p>
          </TableCell>
          {(auth.state.user.admin) ?
          <TableCell align="right" className={classes.icon}>
            {(auth.state.user.admin && (row.daily_iterate || (!row.daily_iterate && row.status === "complete"))) ?
            <IconButton
            className={(deleteDailyButtonDisable(row.daily_iterate)) ? classes.buttonGrey : classes.buttonRed }
            color="primary"
            aria-label="Delete"
            disabled={!auth.state.user.admin || deleteDailyButtonDisable(row.daily_iterate)}
            onClick={() => openDialog(row.id, row.status)}
            >
            <Delete />
            </IconButton>
            : "-" }
          </TableCell>
          : "" }
          {(auth.state.user.admin) ?
          <TableCell align="right" className={classes.icon}>
            <p>-</p>
          </TableCell>
          : "" }
        </TableRow>

        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={(auth.state.user.admin) ? 11 : 8} >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Table>
              <TableBody>
              {(row.daily_iterate) &&
              <TableRow>
              <TableCell colSpan={4}><p>概要：{row.desc}</p> </TableCell>
              </TableRow>
              }
              {(!row.daily_iterate) &&
              <TableRow>
              <TableCell><p>対象ツイート数：{(row.status === "complete") ? row.num_tweets : (row.status === "running") ? "処理中" : "実行前"}</p> </TableCell>
              <TableCell><p>処理開始日時：{(row.status === "complete") ? dayjs(row.started_at).format("YYYY/MM/DD")+" "+dayjs(row.started_at).format("HH:mm:ss") : (row.status === "running") ? "処理中" : "実行前"}</p></TableCell>
              <TableCell><p>処理終了日時：{(row.status === "complete") ? dayjs(row.finished_at).format("YYYY/MM/DD")+" "+dayjs(row.finished_at).format("HH:mm:ss") : (row.status === "running") ? "処理中" : "実行前"}</p></TableCell>
              <TableCell><p>ダウンロード有効期限：{(row.status === "complete") ? dayjs(row.expired_at).format("YYYY/MM/DD")+" "+dayjs(row.expired_at).format("HH:mm:ss") : (row.status === "running") ? "処理中" : "実行前"}</p></TableCell>
              </TableRow>
              }
              </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Layout
      content={
        <>
          <Grid>
          <Typography variant="h5" color="primary">
            タスク一覧
            </Typography>
          </Grid>
          {(success === "copy" || success === "create" || success === "download" || success === "edit" ) && (
            <MuiAlert
              elevation={6}
              variant="filled"
              severity="success"
              className={classes.alert}
            >
              {success === "copy" ? "複製" : (success === "download") ? "ダウンロード" :  (success === "edit") ? "更新" : "登録"}が完了しました
            </MuiAlert>
          )}
          {isError && (
            <Alert severity="error" className={classes.alert}>
              {errorMessage}
            </Alert>
          )}
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                ＜期間指定＞
              </Typography>
              <Typography variant="subtitle2" className={classes.subtitle}>
              ※ダウンロード可能期間はデータ生成後14日までです。<br />
              ※状態が「実行中」および「実行待ちの」場合はタスクの削除はできません。
              </Typography>
              <Table className={`${classes.table} ${classes.tableheader}`}>
                <TableHead>
                  <TableRow>
                    <TableCell>　</TableCell>
                    <TableCell>タスク名</TableCell>
                    <TableCell>設定期間<br />（始点日時）</TableCell>
                    <TableCell>設定期間<br />（終点日時）</TableCell>
                    <TableCell>状態</TableCell>
                    <TableCell>詳細</TableCell>
                    {(auth.state.user.admin) ? <TableCell>編集</TableCell> : ""}
                    <TableCell>ダウンロード</TableCell>
                    {(auth.state.user.admin) ? <TableCell>削除</TableCell> : ""}
                    {(auth.state.user.admin) ? <TableCell>複製</TableCell> : ""}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {nomaltasks.length > 0 ? nomaltasks.map(
                    function (row, index) {
                      return <NormalTaskRow key={index} index={index+1} row={row} />
                    }
                  ) : (
                    <TableRow>
                      <TableCell colSpan={11} align="center">現在実行可能なタスクはありません</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>

          <Grid container justifyContent="center" className={classes.wrapper}>
            {(auth.state.user.admin) ?
              <Button
                variant="contained"
                color="primary"
                onClick={() => onClickCreateButton("normal")}
                disabled={!auth.state.user.admin || createButtonDisable()}
              >
                新規登録
              </Button>
              : "" }
            </Grid>

          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                ＜毎日予約＞
              </Typography>
              <Typography variant="subtitle2" className={classes.subtitle}>
              ※毎日予約は1つのみ設定可能です。<br />
              ※14日より前のデータは自動的に削除されます。
              </Typography>
              <Table className={`${classes.table} ${classes.tableheader}`}>
                <TableHead>
                  <TableRow>
                  <TableCell>　</TableCell>
                    <TableCell>タスク名</TableCell>
                    <TableCell>設定期間<br />（始点日時）</TableCell>
                    <TableCell>設定期間<br />（終点日時）</TableCell>
                    <TableCell>状態</TableCell>
                    <TableCell>詳細</TableCell>
                    {(auth.state.user.admin) ? <TableCell>編集</TableCell> : "" }
                    <TableCell>ダウンロード</TableCell>
                    {(auth.state.user.admin) ? <TableCell>削除</TableCell> : "" }
                    {(auth.state.user.admin) ? <TableCell>複製</TableCell> : "" }
                  </TableRow>
                </TableHead>

                <TableBody>
                  {dailytasks.length > 0 ? dailytasks.map(
                    function (row, index) {
                      return <DailyTaskRow key={index} index={index+1} row={row} />
                    }
                  ) : (
                    <TableRow>
                      <TableCell colSpan={11} align="center">現在実行可能なタスクはありません</TableCell>
                    </TableRow>
                  )}
                </TableBody>

              </Table>
            </Paper>
          </Grid>

          <Grid container justifyContent="center" className={classes.wrapper}>
          {(auth.state.user.admin) ?
            <Button
              variant="contained"
              color="primary"
              onClick={() => onClickCreateButton("daily")}
              disabled={!auth.state.user.admin || createDailyButtonDisable()}
            >
              新規登録
            </Button>
            : "" }
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={deleteTask}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>

        </>
      }
    />
  );
}
